import styled from 'styled-components';
import TypographyBase from '@mui/material/Typography';
import variables from '../../../../shared/styles/settings.module.scss';

export const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    margin-top: 20px;
`;

export const IconCircle = styled.div<{ modeTheme: string }>`
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${(props) =>
        props.modeTheme === 'darkMode'
            ? variables.darkColor
            : variables.primaryColor};
    height: 150px;
    width: 150px;
`;

export const Title = styled(TypographyBase)<{ modeTheme?: string }>`
    color: ${(props) =>
        props.modeTheme === 'darkMode'
            ? variables.darkColor
            : variables.primaryColor};
    text-align: center;
    margin-bottom: 20px;
`;

export const Paragraph = styled(TypographyBase)<{ modeTheme?: string }>`
    color: ${(props) =>
        props.modeTheme === 'darkMode'
            ? variables.darkColor
            : variables.primaryColor};
    text-align: center;
    padding: 10px 50px;
    font-size: 1.3rem;
`;

export const ActionsWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;
